<template>
	<div :class="[
		'c-content-block',
		{'space--bottom': space}
	]">
		<div class="t-display--md-up">
			<template v-if="showTitleOnDesktop && title">
				<div class="c-content-block__titlearea">
					<h2 class="c-content-block__title">{{title}}</h2>
					<p v-if="subtitle && !api" class="c-content-block__subtitle">{{subtitle}}</p>
					<a v-if="subtitle && api" :href="mapLink+linkHref" target="_blank" class="c-content-block__subtitle c-content-block__subtitle--link">{{subtitle}}</a>
				</div>
			</template>
			<slot name="content"></slot>
		</div>
		<div class="t-display--mobile-only">
			<v-expand :id="id" :content-id="contentId">
				<template slot="title" v-if="title">
					{{title}}
				</template>

				<template slot="content">
					<slot name="content"></slot>
				</template>
			</v-expand>
		</div>
	</div>
</template>

<script>
import VExpand from '../../components/expand/VExpand.vue';
import VKeyValue from '../../components/key-value/VKeyValue.vue';

export default {
	name: 'VContentBlock',
	components: {
		VExpand,
		VKeyValue
	},
	props: {
		showTitleOnDesktop: {
			type: Boolean,
			default: true
		},
		title: {
			type: String,
			default: ''
		},
		subtitle: {
			type: String,
			default: ''
		},
		latitude: {
			type: String,
			default: ''
		},
		longitude: {
			type: String,
			default: ''
		},
		api: {
			type: String,
			default: ''
		},
		id: {
			type: String,
			default: ''
		},
		contentId: {
			type: String,
			default: ''
		},
		content: {
			type: Array,
			default: () => []
		},
		space: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			linkHref: "",
			mapLink: "https://www.google.com/maps/place/"
		}
	},
	mounted() {
		if (!this.api) return;
		fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${this.latitude},${this.longitude}&key=${this.api}`)
			.then(response => response.json())
			.then(data => {
				var text = [];
				var linkValue = data.results[0].formatted_address.split(" ");
				for (var i = 0; i < linkValue.length; ++i) {
					text.push(encodeURIComponent(linkValue[i]));
				}
				this.linkHref = text.join("+");
		
			})
			.catch(e => console.error(e));
	}	
}
</script>